import { useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { useGetSubscriberDeliveryDetailsQuery } from '../../api/metricsApi';
import { useToast } from '../../context/ToastContext';
import { errMsg } from '../../utils/errMsg';
import { CHANNEL_LABELS } from '../../utils/channels';
import { rangeFromSearchParams } from '../../utils/dateRange';
import useDeliveryRows from '../../hooks/useDeliveryRows';
import BackHeader from '../../components/BackHeader/BackHeader';
import DeliveriesTable from '../../components/DeliveriesTable/DeliveriesTable';
import s from '../../styles/shared/page.module.css';
import table from '../../styles/shared/table.module.css';

export default function MetricsSubscriberDeliveriesPage() {
  const { id: groupId, subscriberId } = useParams();
  const [searchParams] = useSearchParams();
  const showToast = useToast();

  const range = rangeFromSearchParams(searchParams);

  const {
    data: deliveryDetails,
    isLoading,
    isError,
    error,
  } = useGetSubscriberDeliveryDetailsQuery({ groupId, subscriberId, range });

  useEffect(() => {
    if (isError) showToast('error', 'Deliveries', errMsg(error, 'Could not load messages.'));
  }, [isError, error, showToast]);

  const { allRows, rows, statusFilter, setStatusFilter } = useDeliveryRows(deliveryDetails?.deliveries);

  return (
    <div className={s.page}>
      <BackHeader
        to="/manager/metrics"
        label="Back to Metrics"
        title={`Messages${deliveryDetails?.subscriber_email ? ` — ${deliveryDetails.subscriber_email}` : ''}`}
      />

      <DeliveriesTable
        rows={rows}
        isEmpty={allRows.length === 0}
        isLoading={isLoading}
        emptyLabel="messages"
        statusFilter={statusFilter}
        onStatusFilterChange={setStatusFilter}
        firstColumnHeader="Channel"
        firstColumnBody={(d) => <div className={table.cellInsider}>{CHANNEL_LABELS[d.channel] ?? d.channel}</div>}
      />
    </div>
  );
}
